export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks1.fed7fe4c.jpg";